module.exports = __webpack_public_path__ + "static/media/edge-powered-by-plural.4c0fb884.svg";